import { render } from "./index.vue?vue&type=template&id=490da220&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=490da220&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=490da220&lang=scss&scoped=true"

import exportComponent from "/Users/mingyanglezhao/silva/workSP/yemei-font/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490da220"]])

export default __exports__